import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Header, Aside } from "../components";
import { useNavigate, useLocation } from "react-router-dom";
import {
  socket,
  connectNotificationSocket,
  disconnectNotificationSocket,
} from "../redux/config/socket";
import { notify } from "../helpers/helper";
import { getAccount, getPlans } from "../redux/action/auth";
import { getOrganization } from "../redux/action/organization";
import {
  DefaultToast,
  DriverAssignedToast,
  PickupPriceCounterToast,
  PriceChangeToast,
  PriceCounterToast,
} from "../components/CustomToast";
import { toast } from "react-toastify";
import {
  getNotifications,
  getNotificationsProfile,
} from "../redux/action/notifications";
import { getContracts } from "../redux/action/contracts";
import { getAllScraps } from "../redux/action/scraps";
import { getAvailablePickups, getOrders } from "../redux/action/pickups";

function Frame({ children, userInfo }) {
  const [openAside, setOpenAside] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("__wasteknot")) return navigate("/");
    dispatch(getAccount());
    dispatch(getOrganization());
    dispatch(getNotificationsProfile());
    dispatch(getAllScraps());
    dispatch(getPlans());
  }, [dispatch, navigate]);

  // Open the notification socket while the authenticated shell is mounted, and
  // close it on unmount so it stops retrying once the user leaves the app.
  useEffect(() => {
    connectNotificationSocket();
    return () => disconnectNotificationSocket();
  }, []);

  useEffect(() => {
    const onNotification = (msg) => {
      notify({
        title: msg.title,
        body: msg.body,
      });
      dispatch(getNotificationsProfile());
      dispatch(getNotifications());
    };
    socket.on("notification", onNotification);
    return () => socket.off("notification", onNotification);
  }, [dispatch]);

  useEffect(() => {
    const onPickupAssigned = (msg) => {
      toast(<DriverAssignedToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: "custom-toast",
      });
      dispatch(getNotificationsProfile());
      dispatch(getNotifications());
    };
    socket.on("pickup-assigned", onPickupAssigned);
    return () => socket.off("pickup-assigned", onPickupAssigned);
  }, [dispatch]);

  useEffect(() => {
    const onPriceChangeRequested = (msg) => {
      toast(<PriceChangeToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch(getContracts());
    };

    const onPickupScrapPriceCountered = (msg) => {
      toast(<PickupPriceCounterToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch(getAvailablePickups());
      dispatch(getOrders());
    };

    const onPickupScrapPriceAccepted = (msg) => {
      notify({
        title: msg.title,
        body: msg.body,
      });
      dispatch(getAvailablePickups());
      dispatch(getOrders());
    };

    const onPriceChangeCounter = (msg) => {
      toast(<PriceCounterToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch(getContracts());
    };

    const onPriceChangeAccepted = (msg) => {
      notify({
        title: msg.title,
        body: msg.body,
      });
      dispatch(getContracts());
    };

    socket.on("price-change-requested", onPriceChangeRequested);
    socket.on("pickup-scrap-price-countered", onPickupScrapPriceCountered);
    socket.on("pickup-scrap-price-accepted", onPickupScrapPriceAccepted);
    socket.on("price-change-counter", onPriceChangeCounter);
    socket.on("price-change-accepted", onPriceChangeAccepted);

    return () => {
      socket.off("price-change-requested", onPriceChangeRequested);
      socket.off("pickup-scrap-price-countered", onPickupScrapPriceCountered);
      socket.off("pickup-scrap-price-accepted", onPickupScrapPriceAccepted);
      socket.off("price-change-counter", onPriceChangeCounter);
      socket.off("price-change-accepted", onPriceChangeAccepted);
    };
  }, [dispatch]);

  return (
    // <div className="full-frame ">
    <div className="overlay">
      <Aside openAside={openAside} setOpenAside={setOpenAside} />
      <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
        <Header
          setOpenAside={setOpenAside}
          openAside={openAside}
          userInfo={userInfo}
        />

        <section className="main-container">{children}</section>
      </div>
    </div>
    // </div>
  );
}

export default Frame;
